import authService from "../services/authService";
import presitentStore from "../store";

const log = process.env.NODE_ENV === "development";
const getPayloadStatuses = [400, 500];

export const requestWrapper = async (request) => {
  try {
    const { data } = await request;
    return data;
  } catch (error) {
    let payload = error.message;
    const responseStatus = error.response?.status || -1;
    if (getPayloadStatuses.includes(responseStatus)){
      payload = error.response.data.message;
    }
    presitentStore.store.dispatch({
      type: "messages/setHttpError",
      payload,
    });
    throw error;
  }
};

let refreshPromise = null;

const refreshToken = async () => {
  if (refreshPromise !== null) return refreshPromise;
  const buffer = 60;

  const exp = authService.getExp();
  const expieringIn = exp - (new Date().getTime() + 1) / 1000;

  if (expieringIn - buffer < 0) {
    //refresh token if needed.
    if (log) console.log("refreshing token silently");
    refreshPromise = authService.signinSilent();
    refreshPromise.then(() => (refreshPromise = null));
    return refreshPromise;
  }
  return Promise.resolve();
};
const devInterceptor = async (config) => {
  const user = await authService.getUser();
  await refreshToken(user);
  config.headers.X_USER_EMAIL = user?.profile?.emails[0];
  config.headers.Authorization = `Bearer ${user?.id_token}`;
  return config;
};

const prodInterceptor = async (config) => {
  const user = await authService.getUser();
  await refreshToken(user);

  config.headers.Authorization = `Bearer ${user?.id_token}`;
  return config;
};

export const appendAuthInterceptor = (axiosInstance) => {
  if (process.env.NODE_ENV === "development")
    axiosInstance.interceptors.request.use(devInterceptor);
  // if (process.env.NODE_ENV === "production")
  else axiosInstance.interceptors.request.use(prodInterceptor);
};
